<template>
  <div class="layout">
    <div class="left">
      <div style="padding: 0.96vw;">
        <el-row style="margin-bottom: 0.96vw">
          <el-input
            placeholder="请输入要搜索的内容"
            v-model="drawerKeyWord"
            @input="handleDrawerInput"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleDrawerButton"
            ></el-button>
          </el-input>
        </el-row>
        <!--              <template v-else>-->
        <template v-if="listDrawerQuestion.length">
          <template v-for="key in listDrawerQuestion">
            <div
              class="question-query"
              :key="key.id"
              @click="openDialogAnswer(key)"
            >
              <div
                class="question-query-title"
                v-html="key.errorType"
              ></div>
              <div
                class="question-query-discription"
                v-html="key.briefIntroduction"
              ></div>
            </div>
          </template>
        </template>
        <template
          v-else-if="!listDrawerQuestion.length && isDrawerNotQuery"
        >
          <div style="text-align: center; color: #aaa">
            没有搜索到内容
          </div>
        </template>
        <template v-else>
          <el-collapse
            class="cus-collapse"
            accordion
            v-loading="loadingCollapse"
            @change="handleCollapse"
            style="height: calc(100% - 30px)"
          >
            <template v-for="item in listParents">
              <el-collapse-item
                :key="item.id"
                :title="item.errorType"
                :name="item.id"
              >
                <div
                  v-for="key in item.children"
                  :key="key.id"
                  style="width: 100%; margin-top: 0.48vw"
                >
                  <el-link
                    style="width: 100%; justify-content: flex-start"
                    :underline="false"
                    @click="openDialogAnswer(key)"
                  >
                    <span>{{ `${key.errorType}` }}</span>
                  </el-link>
                </div>
              </el-collapse-item>
            </template>
          </el-collapse>
        </template>
        <!--              </template>-->
      </div>
    </div>
    <div class="right">
      <div slot="title" v-html="dialogData.errorType"></div>
      <div class="custom-dialog" v-html="dialogData.answer"></div>
    </div>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";

let drawerInputTimer = null;

export default {
  data() {
    return {
      drawer: true,
      drawerKeyWord: "",
      listDrawerQuestion: [],
      isDrawerNotQuery: false,
      dialogData: {},
      dialogVisible: false,
      loadingCollapse: false,
      listParents: []
    }
  },
  methods: {
    handleDrawerInput() {
      if (!this.drawerKeyWord) {
        this.listDrawerQuestion = [];
        this.isDrawerNotQuery = false;
        clearTimeout(drawerInputTimer);
        return;
      }
      if (drawerInputTimer) clearTimeout(drawerInputTimer);
      drawerInputTimer = setTimeout(() => {
        this.handleDrawerButton();
      }, 500);
    },
    handleDrawerButton() {
      const API = Baseurl + "helpController/selectByKeyWord";
      const paramsData = {
        keyWord: this.drawerKeyWord,
        type: 2,
      };
      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listDrawerQuestion = data;
          if (!data.length) this.isDrawerNotQuery = true;
        }
      });
    },
    openDialogAnswer(item) {
      this.dialogData = item;
      this.dialogVisible = true;
    },
    handleCollapse(val) {
      if (!val) return;
      const tempObj = this.listParents.find((item) => item.id === val);
      this.getListTable(tempObj);
    },
    getListTable(item) {
      const API = Baseurl + "helpController/selectByPid";
      const paramsData = {
        pid: item.id,
        type: "2",
      };
      ajaxPost(API, paramsData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.$set(item, "children", data);
          if (!data.length) this.$set(item, "isHasChild", false);
        }
      });
    },
    getListParent() {
      const API = Baseurl + "helpController/selectFather";
      ajaxPost(API).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          data.forEach((item) => {
            item.isHasChild = true;
            item.children = [];
          });
          this.listParents = data;
        }
      });
    },
  },
  mounted() {
    this.getListParent()
  }
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;
  .left {
    width: 30%;
    height: 100%;
    overflow: auto;
    border-right: 1px solid #333;
  }

  .right {
    padding: 20px;
    width: 70%;
    height: 100%;
    overflow: auto;
    .title {
      font-size: 20px;
      font-weight: 700;
    }
    p {
      font-size: 18px;
    }
  }

  .el-badge__content.is-fixed {
    top: 20px;
  }

  .el-menu {
    background-color: #061f3e;
  }

  .el-submenu__title {
    color: #fff;
  }

  .el-menu-item {
    color: #fff;
  }

  .el-breadcrumb__inner {
    color: #fff;
  }

  .el-submenu__title:hover,
  .el-menu-item:focus,
  .el-menu-item:hover {
    background-color: #409eff;
  }

  .el-menu-item.is-active {
    color: #fff;
  }

  display: flex;
  flex-direction: row;

  .layout-sider {
    flex: 0 0 200px;
    max-width: 200px;
    min-width: 200px;
    width: 200px;
    background-color: #061f3e;

    .logo {
      height: 64px;
      line-height: 64px;
      background: #002140;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      h1 {
        color: #fff;
        font-size: 20px;
        font-family: Myriad Pro, Helvetica Neue, Arial, Helvetica, sans-serif;
      }
    }
  }

  .layout-section {
    min-height: 100vh;
    background: #fff;
    display: flex;
    position: relative;
    flex-direction: column;
    flex: auto;

    .layout-header {
      height: 64px;
      line-height: 64px;
      padding: 0px;
      background: #061f3e;
      width: 100%;

      .layout-left {
        float: left;
      }

      .layout-imga {
        width: 18px;
        height: 12px;
      }

      .cleft {
        width: 12%;
        text-align: center;
        letter-spacing: 1px;
      }

      .header-left {
        float: left;
        margin-left: 5px;
        line-height: 64px;
        color: #fff;
      }

      .right90 {
        margin-right: 90px;
      }

      .header-right {
        float: right;
        position: relative;
        cursor: pointer;

        .header-right-icon {
          padding: 0 12px;
          color: #fff;
          display: inline-block;
          transition: all 0.3s;
          height: 100%;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }

          .header-avatar {
            margin: 20px 8px 20px 0;
            color: #1890ff;
            background: hsla(0, 0%, 100%, 0.85);
            vertical-align: top;
            width: 24px;
            height: 24px;
            line-height: 24px;
            border-radius: 50%;
            font-family: Chinese Quote, -apple-system, BlinkMacSystemFont,
              Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
              Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji,
              Segoe UI Emoji, Segoe UI Symbol;
            font-size: 14px;
            font-variant: tabular-nums;
            box-sizing: border-box;
            padding: 0;
            list-style: none;
            display: inline-block;
            text-align: center;
            white-space: nowrap;
            position: relative;
            overflow: hidden;

            & > img {
              width: 100%;
              height: 100%;
              display: block;
            }
          }
        }
      }

      .header_i {
        color: #fff;
        font-size: 20px;
      }
    }

    .layout-content {
      margin: 20px 0px 0px 24px;
      padding-top: 0px;
      flex: auto;
      min-height: 0;
      overflow: auto;
      height: calc(100vh - 125px);
    }

    .layout-footer {
      background: #f0f2f5;
      color: rgba(0, 0, 0, 0.65);
      padding: 0;
    }
  }

  .el-tabs__header {
    margin: 0px;
  }
}

.header-right-tips {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: red;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
}
</style>
<style>
.scrollbar-wrapper {
  overflow-x: hidden !important;
}

.custom-dialog img {
  max-width: 100%;
  margin: 10px 0;
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.question-query {
  cursor: pointer;
  margin-bottom: 10px;
}
.question-query + .question-query {
  border-top: 1px solid #ccc;
}

.question-query-title {
  font-weight: bolder;
  font-size: 18px;
  color: #68add5;
  margin-bottom: 5px;
}

.question-query-discription {
  color: #666666;
}

.question-query:hover .question-query-title,
.question-query:hover .question-query-discription {
  color: #dd9c31;
}

.cus-collapse .el-collapse-item .el-collapse-item__header {
  font-weight: bolder;
}
.hx-jiaoxueshipin {
  font-size: 10px;
}
</style>
